import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-end w-full mb-5 mt-5" }, null, -1)
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = {
  class: "pl-3",
  style: {"border-left":"1px solid #ECEFF1"}
}
const _hoisted_5 = {
  key: 1,
  class: "pi pi-ellipsis-h text-base color-blue-grey-lighten-4"
}
const _hoisted_6 = { class: "cursor-pointer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxExport = _resolveComponent("DxExport")
  const _component_DxPaging = _resolveComponent("DxPaging")
  const _component_DxPager = _resolveComponent("DxPager")
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")
  const _component_DxColumn = _resolveComponent("DxColumn")
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")
  const _component_DxGrouping = _resolveComponent("DxGrouping")
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")

  return (_openBlock(), _createBlock("section", null, [
    _hoisted_1,
    _createVNode(_component_DxDataGrid, {
      ref: "refRefundTable",
      onExporting: _ctx.exportGrids,
      id: "refund-table-id",
      class: "receive-item-table",
      "column-auto-width": true,
      "allow-column-reordering": false,
      "show-column-lines": false,
      "show-row-lines": true,
      "show-borders": true,
      "row-alternation-enabled": true,
      "allow-column-resizing": false,
      "word-wrap-enabled": true,
      "data-source": _ctx.data,
      "key-expr": "Id",
      "no-data-text": _ctx.noDataText
    }, {
      "cell-highlighted": _withCtx(({ data }) => [
        _createVNode("div", {
          class: "cursor-pointer",
          onClick: ($event: any) => (_ctx.showDetail(data.data.Id))
        }, [
          _createVNode("p", null, _toDisplayString(data.data?.Resi?.toUpperCase()), 1)
        ], 8, ["onClick"])
      ]),
      cellRefund: _withCtx(({ data }) => [
        _createVNode("div", _hoisted_2, [
          _createVNode("p", _hoisted_3, "Rp. " + _toDisplayString(new Number(data.data.GrandTotal).toLocaleString("id-ID")), 1)
        ])
      ]),
      actionTemplate: _withCtx(({ data }) => [
        _createVNode("div", _hoisted_4, [
          (data.data.StatusPengirimanId === 1)
            ? (_openBlock(), _createBlock("i", {
                key: 0,
                class: "pi pi-ellipsis-h text-base cursor-pointer text-black",
                "aria:haspopup": "true",
                "aria-controls": "overlay_panel",
                onClick: ($event: any) => (_ctx.showDropDown($event, data.data))
              }, null, 8, ["onClick"]))
            : (_openBlock(), _createBlock("i", _hoisted_5))
        ])
      ]),
      ritTemplate: _withCtx(({ data }) => [
        _createVNode("div", _hoisted_6, [
          _createVNode("p", null, _toDisplayString(`Rit ${data.data.Rit}`), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxExport, {
          enabled: true,
          "allow-export-selected-data": false
        }),
        _createVNode(_component_DxPaging, {
          "page-size": 20,
          enabled: true
        }),
        _createVNode(_component_DxPager, {
          visible: true,
          "allowed-page-sizes": _ctx.pageSizes,
          "display-mode": _ctx.displayMode,
          "show-page-size-selector": _ctx.showPageSizeSelector,
          "show-info": _ctx.showInfo,
          "show-navigation-buttons": _ctx.showNavButtons
        }, null, 8, ["allowed-page-sizes", "display-mode", "show-page-size-selector", "show-info", "show-navigation-buttons"]),
        _createVNode(_component_DxFilterRow, { visible: _ctx.showFilterRow }, null, 8, ["visible"]),
        _createVNode(_component_DxHeaderFilter, { visible: _ctx.showHeaderFilter }, null, 8, ["visible"]),
        _createVNode(_component_DxColumnChooser, {
          enabled: true,
          mode: "select",
          title: "Pilih Kolom",
          "allow-search": true
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TanggalJadwalAktif",
          caption: "Tanggal Keberangkatan",
          visible: false,
          alignment: "left",
          "data-type": "date",
          format: "dd-MM-yyyy",
          "min-width": 150
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "LastUpdate",
          caption: "Tanggal Refund",
          "min-width": 150,
          alignment: "left",
          "data-type": "date",
          format: "dd-MM-yyyy"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Rit",
          caption: "RIT",
          "cell-template": "ritTemplate",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          alignment: "left",
          "data-field": "Resi",
          caption: "No. Resi",
          "min-width": 200,
          "cell-template": "cell-highlighted"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Jadwal",
          caption: "Jadwal",
          "min-width": 150,
          alignment: "left",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NamaAgenAsal",
          caption: "Ag. Asal",
          visible: false,
          "min-width": 150
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NamaAgenTujuan",
          caption: "Ag. Tujuan",
          alignment: "left",
          visible: false,
          "min-width": 170
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NamaPengirim",
          caption: "Pengirim",
          "min-width": 150,
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "HpPengirim",
          caption: "No. Pengirim",
          visible: false,
          width: 130
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NamaPenerima",
          caption: "Penerima",
          visible: false,
          "min-width": 150
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "HpPenerima",
          caption: "No. Penerima",
          visible: false,
          width: 130
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TotalColly",
          caption: "Total Koli",
          "min-width": 100,
          alignment: "left"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "GrandTotal",
          caption: "Total Refund",
          alignment: "left",
          visible: true,
          "data-type": "number",
          "min-width": 200,
          "cell-template": "cellRefund"
        }),
        _createVNode(_component_DxGroupPanel, {
          visible: true,
          "empty-panel-text": "Drag kolom ke sini untuk mengelompokkan menurut kolom tersebut"
        }),
        _createVNode(_component_DxGrouping, {
          "auto-expand-all": _ctx.autoExpandAll,
          "context-menu-enabled": true,
          "expand-mode": "rowClick"
        }, null, 8, ["auto-expand-all"]),
        _createVNode(_component_DxSearchPanel, { visible: true })
      ]),
      _: 1
    }, 8, ["onExporting", "data-source", "no-data-text"]),
    _createVNode(_component_DxLoadPanel, {
      "close-on-outside-click": false,
      visible: _ctx.loading,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.loading = $event)),
      position: _ctx.position,
      shading: true,
      "shading-color": "rgba(0,0,0,0.4)"
    }, null, 8, ["visible", "position"])
  ]))
}